import axios from "axios"


export function indexTeam(page = 1) {
    const url = `v1/trainee/team?page=${page}`

    return axios.get(url).then(response => response.data)
}